"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = exports.impl = exports.asyncHooks = void 0;
exports.asyncHooks = undefined;
const impl = (implimentations) => {
    exports.asyncHooks = implimentations;
};
exports.impl = impl;
const reset = () => {
    exports.asyncHooks = undefined;
};
exports.reset = reset;
//# sourceMappingURL=asyncHooksInterface.js.map